export enum CityType {
    Billing,
    Shipping
}
